export default __webpack_public_path__ + "static/media/undraw_diet.0424d96d.svg";